// extracted by mini-css-extract-plugin
export default {"content":"AccessProvider_content__yhhAC"};